module.exports = __webpack_public_path__ + "img/icon_send.952e973f.svg";